(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-care-guide-instructions"] && !Shopify.designMode) return;
  try {
    
	if (!window.LTASCGInstructionsTabsInit) {
		window.LTASCGInstructionsTabsInit = true

		class LTASCGInstructionsTabs {
			constructor(rootEl) {
				this._rootEl = rootEl
				this._onTriggerClick = this._onTriggerClick.bind(this)
				this._onTriggerKeydown = this._onTriggerKeydown.bind(this)
				this._cleanups = []
			}

			connect() {
				this._tabTriggers = [...this._rootEl.querySelectorAll('[data-tab-trigger]')]
				this._tabPanels = [...this._rootEl.querySelectorAll('[data-tab-panel]')]

				if (!this._tabTriggers.length || !this._tabPanels.length) return

				this._tabTriggers.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTriggerClick)
					triggerEl.addEventListener('keydown', this._onTriggerKeydown)
					this._cleanups.push(() => triggerEl.removeEventListener('click', this._onTriggerClick))
					this._cleanups.push(() => triggerEl.removeEventListener('keydown', this._onTriggerKeydown))
				})
			}

			disconnect() {
				this._cleanups.forEach((cleanup) => cleanup())
				this._cleanups = []
			}

			_onTriggerClick(event) {
				this._activateTab(event.currentTarget)
			}

			_onTriggerKeydown(event) {
				const triggerEl = event.currentTarget
				const triggerIndex = this._tabTriggers.indexOf(triggerEl)

				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault()
					this._activateTab(triggerEl)
					return
				}

				if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
					event.preventDefault()
					const direction = event.key === 'ArrowRight' ? 1 : -1
					const nextIndex = (triggerIndex + direction + this._tabTriggers.length) % this._tabTriggers.length
					this._tabTriggers[nextIndex]?.focus()
				}
			}

			_activateTab(triggerEl) {
				if (triggerEl.classList.contains('is-active')) return

				const tabId = triggerEl.dataset.tabId
				const panelEl = this._rootEl.querySelector(`[data-tab-panel][data-tab-id="${tabId}"]`)

				if (!panelEl) return

				this._tabTriggers.forEach((el) => {
					const isActive = el === triggerEl
					el.classList.toggle('is-active', isActive)
					el.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this._tabPanels.forEach((el) => {
					const isActive = el === panelEl
					el.classList.toggle('is-active', isActive)
					el.toggleAttribute('hidden', !isActive)
				})
			}

			activateFromTrigger(triggerEl) {
				this._activateTab(triggerEl)
			}
		}

		const tabInstances = new WeakMap()

		const initTabs = (rootEl) => {
			if (tabInstances.has(rootEl)) return

			const instance = new LTASCGInstructionsTabs(rootEl)
			instance.connect()
			tabInstances.set(rootEl, instance)
		}

		document.querySelectorAll('[data-cg-instructions-tabs]').forEach(initTabs)

		if (window.Shopify?.designMode) {
			document.addEventListener('shopify:section:load', (event) => {
				event.target.querySelectorAll('[data-cg-instructions-tabs]').forEach(initTabs)
			})

			document.addEventListener('shopify:block:select', (event) => {
				const rootEl = event.target.closest('[data-cg-instructions-tabs]')
				if (!rootEl) return

				initTabs(rootEl)

				const triggerEl = event.target.closest('[data-tab-trigger]')
				if (!triggerEl) return

				tabInstances.get(rootEl)?.activateFromTrigger(triggerEl)

				triggerEl.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
					inline: 'nearest',
				})
			})
		}
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-featured-collection"] && !Shopify.designMode) return;
  try {
    
	const l_featuredPlpQuickLinksCache = new Map()

	if (!customElements.get('l-featured-plp-quick-links')) {
		class LTAFeaturedPlpQuickLinks extends HTMLElement {
			constructor() {
				super()

				this.abortController = null
				this.sectionId = ''
				this.templateSuffix = ''
				this._activeRequestId = null
				this._onClick = this._onClick.bind(this)
				this._onPopState = this._onPopState.bind(this)
			}

			connectedCallback() {
				this.sectionId = this.dataset.sectionId || ''
				const sectionEl = this.sectionEl

				if (this.dataset.isPageTemplate === 'true' && sectionEl) {
					sectionEl.dataset.featuredPlpPageTemplate = 'true'
				}

				this.templateSuffix = this.dataset.templateSuffix || ''
				this.isPageTemplate = sectionEl?.dataset.featuredPlpPageTemplate === 'true'
				this.currentCollectionUrl =
					sectionEl?.dataset.featuredPlpCurrentCollectionUrl || this.dataset.currentCollectionUrl || ''

				if (this.isPageTemplate && sectionEl && this.currentCollectionUrl) {
					sectionEl.dataset.featuredPlpCurrentCollectionUrl = this.currentCollectionUrl
				}

				this._syncActiveLinks(this._getActiveCollectionUrl())
				this._cacheCurrentSection()
				this.addEventListener('click', this._onClick)

				if (!this.isPageTemplate) {
					window.addEventListener('popstate', this._onPopState)
				}
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
				window.removeEventListener('popstate', this._onPopState)
				this.abortController?.abort()
			}

			get sectionEl() {
				if (!this.sectionId) return null
				return document.getElementById(`shopify-section-${this.sectionId}`)
			}

			_getActiveCollectionUrl() {
				if (this.isPageTemplate) {
					return this.sectionEl?.dataset.featuredPlpCurrentCollectionUrl || this.currentCollectionUrl || ''
				}

				return window.location.href
			}

			_onClick(event) {
				const linkEl = event.target.closest('[data-quick-link]')
				if (!linkEl || !this.contains(linkEl)) return

				const href = linkEl.getAttribute('href')
				if (!href || href === '#') return
				if (!this._isCollectionUrl(href)) return

				event.preventDefault()

				const targetPath = this._normalizeCollectionPath(href)
				const currentPath = this._normalizeCollectionPath(this._getActiveCollectionUrl())

				if (targetPath && targetPath === currentPath) {
					this._syncActiveLinks(href)
					return
				}

				this._syncActiveLinks(href)

				const updateHistory = !this.isPageTemplate
				const historyUrl = this._buildHistoryUrl(href).toString()
				this._navigateToCollection(historyUrl, updateHistory, href)
			}

			_onPopState(event) {
				if (this.isPageTemplate) return
				if (event.state && !event.state.featuredPlpQuickLink) return
				if (!this._isCollectionUrl(window.location.href)) return

				this._navigateToCollection(this._buildHistoryUrl(window.location.href).toString(), false, window.location.href)
			}

			_isCollectionUrl(href) {
				try {
					const url = new URL(href, window.location.origin)
					if (url.origin !== window.location.origin) return false

					const segments = url.pathname.split('/').filter(Boolean)
					const collectionsIndex = segments.indexOf('collections')
					if (collectionsIndex === -1) return false
					if (!segments[collectionsIndex + 1]) return false
					if (segments.includes('products')) return false

					return true
				} catch {
					return false
				}
			}

			_buildHistoryUrl(href) {
				const url = new URL(href, window.location.origin)
				url.search = ''

				if (this.templateSuffix) {
					url.searchParams.set('view', this.templateSuffix)
				}

				return url
			}

			_buildFetchUrl(href) {
				const url = new URL(href, window.location.origin)
				url.search = ''

				if (!this.isPageTemplate && this.templateSuffix) {
					url.searchParams.set('view', this.templateSuffix)
				}

				if (this.sectionId) url.searchParams.set('section_id', this.sectionId)

				return url
			}

			_getCacheKey(href) {
				const collectionPath = this._normalizeCollectionPath(href)

				if (this.isPageTemplate) {
					return collectionPath
				}

				return this._buildHistoryUrl(href).toString()
			}

			_normalizeCollectionPath(href) {
				try {
					const url = new URL(href, window.location.origin)
					const path = url.pathname.replace(/\/+$/, '')
					return path || '/'
				} catch {
					return ''
				}
			}

			_syncActiveLinks(targetHref = this._getActiveCollectionUrl()) {
				const currentPath = this._normalizeCollectionPath(targetHref)

				this.querySelectorAll('[data-quick-link]').forEach((linkEl) => {
					const href = linkEl.getAttribute('href')
					if (!href || href === '#') {
						linkEl.classList.remove('is-active')
						return
					}

					const linkPath = this._normalizeCollectionPath(href)
					linkEl.classList.toggle('is-active', linkPath !== '' && linkPath === currentPath)
				})
			}

			_updateTitle(sectionEl, targetHref = '') {
				const titleEl = sectionEl?.querySelector('[data-featured-plp-title]')
				if (!titleEl) return

				const currentPath = this._normalizeCollectionPath(targetHref || this._getActiveCollectionUrl())
				if (!currentPath) return

				const matchingLinkEl = [...sectionEl.querySelectorAll('[data-quick-link]')].find((linkEl) => {
					const href = linkEl.getAttribute('href')
					if (!href || href === '#') return false

					return this._normalizeCollectionPath(href) === currentPath
				})

				const heading = matchingLinkEl?.dataset.heading?.trim()
				if (!heading) return

				titleEl.textContent = heading
			}

			_cacheCurrentSection() {
				const sectionEl = this.sectionEl
				if (!sectionEl) return

				const cacheKey = this._getCacheKey(this._getActiveCollectionUrl())
				l_featuredPlpQuickLinksCache.set(cacheKey, {
					sectionHTML: sectionEl.innerHTML,
				})
			}

			_navigateToCollection(historyUrl, updateHistory = true, fetchHref = historyUrl) {
				if (!this.sectionId || !this.sectionEl) {
					window.location.href = this.isPageTemplate ? fetchHref : historyUrl
					return
				}

				if (updateHistory) this._cacheCurrentSection()

				const cacheKey = this._getCacheKey(fetchHref)
				const cached = l_featuredPlpQuickLinksCache.get(cacheKey)

				if (cached) {
					this._renderCachedSection(cached, historyUrl, updateHistory, fetchHref)
					return
				}

				const requestId = Symbol('featured-plp-quick-link')
				this._activeRequestId = requestId
				this._showLoading()

				this.abortController?.abort()
				this.abortController = new AbortController()

				const fetchUrl = this._buildFetchUrl(fetchHref).toString()

				fetch(fetchUrl, { signal: this.abortController.signal })
					.then((response) => {
						if (!response.ok) throw new Error(`Failed to fetch collection: ${response.status}`)
						return response.text()
					})
					.then((html) => {
						if (this._activeRequestId !== requestId) return

						const pageData = this._parseSection(html)
						l_featuredPlpQuickLinksCache.set(cacheKey, pageData)

						if (updateHistory) {
							history.pushState({ featuredPlpQuickLink: true }, '', historyUrl)
						}

						this._applySection(pageData, fetchHref)
					})
					.catch((error) => {
						if (error.name === 'AbortError') return
						console.error('[LTAFeaturedPlpQuickLinks] Fetch error:', error)

						if (this.isPageTemplate) {
							window.location.href = fetchHref
							return
						}

						window.location.href = historyUrl
					})
					.finally(() => {
						if (this._activeRequestId === requestId) {
							this._hideLoading()
						}
					})
			}

			_renderCachedSection(pageData, historyUrl, updateHistory, fetchHref = historyUrl) {
				const requestId = Symbol('featured-plp-quick-link-cache')
				this._activeRequestId = requestId
				this._showLoading()

				window.setTimeout(() => {
					if (this._activeRequestId !== requestId) return

					try {
						if (updateHistory) {
							history.pushState({ featuredPlpQuickLink: true }, '', historyUrl)
						}

						this._applySection(pageData, fetchHref)
					} finally {
						this._hideLoading()
					}
				}, 400)
			}

			_showLoading() {
				document.documentElement.classList.add('is-featured-plp-loading')

				let overlay = document.querySelector('[data-featured-plp-loading]')
				if (overlay) return

				overlay = document.createElement('div')
				overlay.className = 'l-sFeaturedPLP__loading'
				overlay.setAttribute('data-featured-plp-loading', '')
				overlay.setAttribute('role', 'status')
				overlay.setAttribute('aria-live', 'polite')
				overlay.innerHTML = `
					<span class="l-sFeaturedPLP__loading-spinner" aria-hidden="true"></span>
					<span class="l-input-sr-only">Loading</span>
				`
				document.body.appendChild(overlay)
			}

			_hideLoading() {
				document.documentElement.classList.remove('is-featured-plp-loading')
				document.querySelector('[data-featured-plp-loading]')?.remove()
			}

			_parseSection(html) {
				const doc = new DOMParser().parseFromString(html, 'text/html')
				const newSection = doc.getElementById(`shopify-section-${this.sectionId}`) || doc.body?.firstElementChild

				if (!newSection) {
					throw new Error('Featured collection section not found')
				}

				newSection.querySelectorAll('script').forEach((script) => script.remove())

				return {
					sectionHTML: newSection.innerHTML,
				}
			}

			_applySection(pageData, fetchHref = '') {
				const sectionEl = this.sectionEl
				if (!sectionEl || !pageData?.sectionHTML) {
					throw new Error('Featured collection section not found')
				}

				if (fetchHref) {
					sectionEl.dataset.featuredPlpCurrentCollectionUrl = fetchHref
				}

				const quickLinksEl = sectionEl.querySelector('l-featured-plp-quick-links')
				const quickLinksOffset = quickLinksEl ? quickLinksEl.getBoundingClientRect().top : null

				const temp = document.createElement('div')
				temp.innerHTML = pageData.sectionHTML
				temp.querySelectorAll('.aos-animate').forEach((el) => el.classList.remove('aos-animate'))

				sectionEl.innerHTML = temp.innerHTML

				const nextQuickLinksEl = sectionEl.querySelector('l-featured-plp-quick-links')

				if (nextQuickLinksEl && fetchHref) {
					nextQuickLinksEl.dataset.currentCollectionUrl = fetchHref
				}

				this._updateTitle(sectionEl, fetchHref)

				sectionEl.querySelectorAll('img.is-loading').forEach((img) => {
					if (!img.complete) return
					img.classList.remove('is-loading')
					img.parentElement?.classList.remove('is-loading')
				})

				if (nextQuickLinksEl && quickLinksOffset !== null) {
					const offsetDiff = nextQuickLinksEl.getBoundingClientRect().top - quickLinksOffset
					if (offsetDiff !== 0) {
						window.scrollBy(0, offsetDiff)
					}
				}

				requestAnimationFrame(() => {
					sectionEl.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }))
				})
			}
		}

		customElements.define('l-featured-plp-quick-links', LTAFeaturedPlpQuickLinks)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-find-your-size"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-find-size-steps')) {
		class LTAFindSizeSteps extends HTMLElement {
			connectedCallback() {
				this.swiperEl = this.querySelector('[data-role="text-swiper"]')
				this.counterEl = this.querySelector('[data-step-counter]')
				this.prevBtn = this.querySelector('[data-step-prev]')
				this.nextBtn = this.querySelector('[data-step-next]')
				this.mediaItems = Array.from(this.querySelectorAll('[data-media-index]'))

				if (!this.swiperEl) return

				this._checkReady = this._checkReady.bind(this)
				this._checkReady()
			}

			_checkReady() {
				if (this.swiperEl.swiperCarousel) {
					this._wire()
					return
				}

				requestAnimationFrame(this._checkReady)
			}

			_wire() {
				const swiper = this.swiperEl.swiperCarousel

				this.prevBtn?.addEventListener('click', () => this.swiperEl.slideTo(swiper.activeIndex - 1))
				this.nextBtn?.addEventListener('click', () => this.swiperEl.slideTo(swiper.activeIndex + 1))

				swiper.on('slideChange', () => this._syncState(swiper.activeIndex))

				this._syncState(swiper.activeIndex)
			}

			_syncState(index) {
				const total = this.mediaItems.length

				this.mediaItems.forEach((item, itemIndex) => {
					item.classList.toggle('is-active', itemIndex === index)
				})

				if (this.counterEl) this.counterEl.textContent = `${index + 1} / ${total}`
				if (this.prevBtn) this.prevBtn.disabled = index <= 0
				if (this.nextBtn) this.nextBtn.disabled = index >= total - 1
			}
		}

		customElements.define('l-find-size-steps', LTAFindSizeSteps)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-hp-best-loved-gear"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-best-loved-gear-tabs')) {
		class LTABestLovedGearTabs extends HTMLElement {
			constructor() {
				super()
				this._onTriggerClick = this._onTriggerClick.bind(this)
				this._onTriggerKeydown = this._onTriggerKeydown.bind(this)
				this._onBlockSelect = this._onBlockSelect.bind(this)
				this._cleanups = []
			}

			connectedCallback() {
				this._rootEl = this.closest('[data-best-loved-gear-root]')
				this._tabListEl = this.querySelector('[data-tab-list]')
				this._tabTriggers = [...this.querySelectorAll('[data-tab-trigger]')]
				this._tabPanels = [...this.querySelectorAll('[data-tab-panel]')]

				if (!this._tabTriggers.length || !this._tabPanels.length) return

				this._tabTriggers.forEach((triggerEl) => {
					triggerEl.addEventListener('click', this._onTriggerClick)
					triggerEl.addEventListener('keydown', this._onTriggerKeydown)
					this._cleanups.push(() => triggerEl.removeEventListener('click', this._onTriggerClick))
					this._cleanups.push(() => triggerEl.removeEventListener('keydown', this._onTriggerKeydown))
				})

				if (window.Shopify?.designMode) {
					document.addEventListener('shopify:block:select', this._onBlockSelect)
					this._cleanups.push(() => document.removeEventListener('shopify:block:select', this._onBlockSelect))
				}
			}

			disconnectedCallback() {
				this._cleanups.forEach((cleanup) => cleanup())
				this._cleanups = []
			}

			_onTriggerClick(event) {
				const triggerEl = event.currentTarget
				this._activateTab(triggerEl)
			}

			_onTriggerKeydown(event) {
				const triggerEl = event.currentTarget
				const triggerIndex = this._tabTriggers.indexOf(triggerEl)

				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault()
					this._activateTab(triggerEl)
					return
				}

				if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
					event.preventDefault()
					const direction = event.key === 'ArrowRight' ? 1 : -1
					const nextIndex = (triggerIndex + direction + this._tabTriggers.length) % this._tabTriggers.length
					this._tabTriggers[nextIndex]?.focus()
				}
			}

			_onBlockSelect(event) {
				if (!this.contains(event.target)) return

				const triggerEl = event.target.closest('[data-tab-trigger]')
				if (!triggerEl) return

				this._activateTab(triggerEl)

				triggerEl.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
					inline: 'nearest',
				})
			}

			_activateTab(triggerEl) {
				if (triggerEl.classList.contains('is-active')) return

				const tabId = triggerEl.dataset.tabId
				const panelEl = this.querySelector(`[data-tab-panel][data-tab-id="${tabId}"]`)

				if (!panelEl) return

				this._tabTriggers.forEach((el) => {
					const isActive = el === triggerEl
					el.classList.toggle('is-active', isActive)
					el.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this._tabPanels.forEach((el) => {
					const isActive = el === panelEl
					el.classList.toggle('is-active', isActive)
					el.toggleAttribute('hidden', !isActive)
				})

				const collectionUrl = triggerEl.dataset.collectionUrl
				if (collectionUrl && this._rootEl) {
					const openInNewTab = triggerEl.dataset.openInNewTab === 'true'
					this._rootEl.querySelectorAll('[data-best-loved-gear-cta]').forEach((ctaEl) => {
						ctaEl.href = collectionUrl
						if (openInNewTab) {
							ctaEl.setAttribute('target', '_blank')
							ctaEl.setAttribute('rel', 'noopener noreferrer')
						} else {
							ctaEl.removeAttribute('target')
							ctaEl.removeAttribute('rel')
						}
					})
				}

				requestAnimationFrame(() => {
					panelEl.querySelector('l-swiper-carousel')?.swiperCarousel?.update()
				})
			}
		}

		customElements.define('l-best-loved-gear-tabs', LTABestLovedGearTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-recommendations"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-recommendations')) {
		class LTAProductRecommendations extends HTMLElement {
			connectedCallback() {
				// Skip instances created while parsing fetch HTML (DOMParser connects them)
				if (this.ownerDocument !== document) return
				if (this.querySelector('[data-recommendations]')) return
				if (!this.dataset.url) return

				this._observer = new IntersectionObserver(
					(entries, observer) => {
						if (!entries[0]?.isIntersecting) return

						observer.unobserve(this)
						this._loadRecommendations()
					},
					// Start fetching ~2 sections before this block enters the viewport
					{ rootMargin: '0px 0px 700px 0px' }
				)

				this._observer.observe(this)
			}

			disconnectedCallback() {
				this._observer?.disconnect()
			}

			_loadRecommendations() {
				if (this._loadStarted) return

				this._loadStarted = true

				fetch(this.dataset.url, { priority: 'low' })
					.then((response) => {
						if (!response.ok) throw new Error(response.status)
						return response.text()
					})
					.then((html) => {
						// Use a disconnected node so nested custom elements are not upgraded/connected
						const temp = document.createElement('div')
						temp.innerHTML = html

						const nextEl = temp.querySelector('l-product-recommendations')
						const hasProducts = Boolean(temp?.querySelector('[data-recommendations]'))

						if (!hasProducts) {
							this.closest('.shopify-section')?.classList.add('l-hidden')
							return
						}

						this.innerHTML = nextEl.innerHTML
					})
					.catch((error) => {
						console.error('[LTAProductRecommendations]', error)
						this.closest('.shopify-section')?.classList.add('l-hidden')
					})
			}
		}

		customElements.define('l-product-recommendations', LTAProductRecommendations)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-size-guide"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-size-guide')) {
		class LTAProductSizeGuide extends HTMLElement {
			constructor() {
				super()
				this.onClick = this.onClick.bind(this)
			}

			connectedCallback() {
				this.tabTriggers = Array.from(this.querySelectorAll('[data-tab-trigger]'))
				this.tabPanels = Array.from(this.querySelectorAll('[data-tab-panel]'))

				this.addEventListener('click', this.onClick)
				this.selectTab(this.dataset.defaultTab || this.tabTriggers[0]?.dataset.tabTrigger)
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick)
			}

			onClick(event) {
				const tabTrigger = event.target.closest('[data-tab-trigger]')
				if (tabTrigger) {
					this.selectTab(tabTrigger.dataset.tabTrigger)
					return
				}

				const unitTrigger = event.target.closest('[data-unit-toggle]')
				if (unitTrigger) {
					this.setUnit(unitTrigger)
				}
			}

			selectTab(tabKey) {
				if (!tabKey) return

				this.tabTriggers.forEach((trigger) => {
					const isActive = trigger.dataset.tabTrigger === tabKey
					trigger.classList.toggle('is-active', isActive)
					trigger.setAttribute('aria-selected', isActive ? 'true' : 'false')
				})

				this.tabPanels.forEach((panel) => {
					panel.hidden = panel.dataset.tabPanel !== tabKey
				})
			}

			setUnit(trigger) {
				const row = trigger.closest('[data-active-unit]')
				if (!row) return

				row.setAttribute('data-active-unit', trigger.dataset.unitToggle)

				row.querySelectorAll('[data-unit-toggle]').forEach((button) => {
					button.classList.toggle('is-active', button === trigger)
				})
			}
		}

		customElements.define('l-product-size-guide', LTAProductSizeGuide)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-size-table"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-size-table')) {
		class LTASizeTable extends HTMLElement {
			constructor() {
				super()
				this._onClick = this._onClick.bind(this)
			}

			connectedCallback() {
				this.addEventListener('click', this._onClick)
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
			}

			_onClick(event) {
				const unitTrigger = event.target.closest('[data-unit-toggle]')
				if (unitTrigger) {
					this._setUnit(unitTrigger)
					return
				}

				const printTrigger = event.target.closest('[data-print-outline]')
				if (printTrigger) {
					event.preventDefault()
					this._printOutline(printTrigger)
				}
			}

			_setUnit(trigger) {
				const row = trigger.closest('[data-active-unit]')
				if (!row) return

				row.setAttribute('data-active-unit', trigger.dataset.unitToggle)

				row.querySelectorAll('[data-unit-toggle]').forEach((button) => {
					button.classList.toggle('is-active', button === trigger)
				})
			}

			_printOutline(trigger) {
				const src = trigger.dataset.printOutline
				if (!src) return

				const printWindow = window.open('', '_blank', 'noopener')
				if (!printWindow) return

				const label = trigger.dataset.printLabel || ''
				const doc = printWindow.document

				doc.title = label
				doc.body.style.margin = '0'

				const img = doc.createElement('img')
				img.src = src
				img.alt = label
				img.style.width = '100%'
				img.addEventListener('load', () => printWindow.print())

				doc.body.appendChild(img)
			}
		}

		customElements.define('l-size-table', LTASizeTable)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-sub-collections"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-sub-collections')) {
		class LTASubCollections extends HTMLElement {
			constructor() {
				super()
				this._onClick = this._onClick.bind(this)
			}

			connectedCallback() {
				this.filterButtons = this.querySelectorAll('[data-filter]')
				this.groups = this.querySelectorAll('[data-group]')
				this.addEventListener('click', this._onClick)

				if (typeof l_setPdpPrevCollectionPage === 'function') {
					l_setPdpPrevCollectionPage(this.dataset.pdpReturnTitle || '')
				}
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
			}

			_onClick(event) {
				const trigger = event.target.closest('[data-filter]')
				if (!trigger || !this.contains(trigger)) return

				this._setFilter(trigger.dataset.filter, trigger)
			}

			_setFilter(filter, activeTrigger) {
				this.filterButtons.forEach((button) => {
					const isActive = button === activeTrigger
					button.classList.toggle('is-active', isActive)
					button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
				})

				this.groups.forEach((group) => {
					const isMatch = filter === 'all' || group.dataset.group === filter
					group.classList.toggle('l-hidden', !isMatch)
				})

				if (filter === 'all') return

				requestAnimationFrame(() => {
					const target = this.querySelector(`[data-group="${CSS.escape(filter)}"]`)
					if (!target) return

					const fitsScreen = target.getBoundingClientRect().height <= window.innerHeight
					target.scrollIntoView({
						behavior: 'smooth',
						block: fitsScreen ? 'center' : 'start',
					})
				})
			}
		}

		customElements.define('l-sub-collections', LTASubCollections)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
	if (!customElements.get('l-pdp-breadcrumb')) {
		class LTAPdpBreadcrumb extends HTMLElement {
			connectedCallback() {
				this.linkEl = this.querySelector('[data-pdp-breadcrumb-link]')
				this.sepEl = this.querySelector('[data-pdp-breadcrumb-sep]')
				if (!this.linkEl) return

				this._resolve()
			}

			_resolve() {
				const collectionUrl = this.linkEl.dataset.collectionUrl || ''
				const collectionTitle = this.linkEl.dataset.collectionTitle || ''
				const typeUrl = this.linkEl.dataset.typeUrl || ''
				const typeTitle = this.linkEl.dataset.typeTitle || ''

				const collectionPath = typeof l_normalizePathname === 'function' ? l_normalizePathname(collectionUrl) : collectionUrl
				const prevFromStorage = typeof l_getPdpPrevCollectionPage === 'function' ? l_getPdpPrevCollectionPage() : null

				let prevUrl = ''
				let prevTitle = ''

				try {
					if (document.referrer) {
						const referrer = new URL(document.referrer)
						if (
							referrer.origin === window.location.origin &&
							typeof l_isCollectionPagePath === 'function' &&
							l_isCollectionPagePath(referrer.pathname)
						) {
							prevUrl = `${referrer.pathname}${referrer.search}`
							const referrerPath = l_normalizePathname(referrer.pathname)
							if (prevFromStorage && l_normalizePathname(prevFromStorage.url) === referrerPath) {
								prevTitle = prevFromStorage.title || ''
							}
						}
					}
				} catch (error) {
					/* ignore invalid referrer */
				}

				const prevPath = typeof l_normalizePathname === 'function' ? l_normalizePathname(prevUrl) : prevUrl

				let href = ''
				let title = ''

				if (prevUrl && prevPath && prevPath !== collectionPath) {
					href = prevUrl
					title = prevTitle || prevPath.split('/').pop().replace(/-/g, ' ')
				} else if (collectionUrl) {
					href = collectionUrl
					title = collectionTitle
				} else if (typeUrl) {
					href = typeUrl
					title = typeTitle
				}

				if (!href) {
					this.linkEl.hidden = true
					if (this.sepEl) this.sepEl.hidden = true
					return
				}

				this.linkEl.hidden = false
				this.linkEl.href = href
				this.linkEl.textContent = title
				if (this.sepEl) this.sepEl.hidden = false
			}
		}

		customElements.define('l-pdp-breadcrumb', LTAPdpBreadcrumb)
	}

  } catch(e) { console.error(e); }
})();
})();
